export default "__VITE_ASSET__iTM5fe6L__"